module.exports = __webpack_public_path__ + "assets/img/Kaplan-Professional-Pillar-Page-Resource.fe2b27fd.jpg";